import { cn } from '@workspace/ui/lib/utils'
import * as React from 'react'

export interface EmptyStateProps extends React.HTMLAttributes<HTMLDivElement> {
  /** Icon element to display */
  icon?: React.ReactNode
  /** Title text */
  title: string
  /** Optional description */
  description?: string
  /** Optional action button/link */
  action?: React.ReactNode
  /** Use dashed border style */
  dashed?: boolean
}

export const EmptyState = React.forwardRef<HTMLDivElement, EmptyStateProps>(
  ({ icon, title, description, action, dashed = true, className, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={cn(
          'flex flex-col items-center justify-center p-8 rounded-xl border text-center',
          dashed ? 'border-dashed border-border' : 'border-border',
          className
        )}
        {...props}
      >
        {icon && <div className="text-muted-foreground mb-3">{icon}</div>}
        <p className="text-muted-foreground font-medium">{title}</p>
        {description && <p className="text-sm text-muted-foreground/70 mt-1">{description}</p>}
        {action && <div className="mt-4">{action}</div>}
      </div>
    )
  }
)

EmptyState.displayName = 'EmptyState'
